// AI-010 exact origins: retain explicit default ports; never use URL.origin,
// which silently removes them. Django remains the authoritative validator.
export function normalizeWebsiteOrigin(value) {
  const invalid = () => { throw new Error("Enter a valid HTTP(S) origin only, without a path, query, fragment, credentials or wildcard."); };
  if (typeof value !== "string" || !value || value.length > 2048 || /[^\x21-\x7e]|[*\\%?#]/.test(value)) return invalid();
  const match = /^(https?):\/\/(\[[0-9a-f:.]+\]|[a-z0-9.-]+)(?::([0-9]+))?$/i.exec(value);
  if (!match) return invalid();
  const [, scheme, rawHost, rawPort] = match;
  let host = rawHost.toLowerCase();
  if (rawPort && (Number(rawPort) < 1 || Number(rawPort) > 65535)) return invalid();
  if (!host.startsWith("[")) {
    if (host.length > 253 || !host.split(".").every(label => /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(label))) return invalid();
    if (/^[0-9.]+$/.test(host)) {
      const parts = host.split(".");
      if (parts.length !== 4 || !parts.every(part => /^(0|[1-9][0-9]{0,2})$/.test(part) && Number(part) <= 255)) return invalid();
    } else if (/^(0x[0-9a-f]+|[0-9]+)$/.test(host.split(".").pop())) return invalid();
  }
  try {
    if (host.startsWith("[")) host = new URL(`${scheme.toLowerCase()}://${host}`).hostname;
  } catch { return invalid(); }
  return `${scheme.toLowerCase()}://${host}${rawPort ? `:${Number(rawPort)}` : ""}`;
}
